exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._25a6Mcvwdvvpjq7BHRR0zN{outline:none;max-width:none;max-height:none}", ""]);
// Exports
exports.locals = {
	"dialog": "_25a6Mcvwdvvpjq7BHRR0zN"
};